import * as React from 'react';
import { Component } from 'react';
import { Field, Form, reduxForm } from 'redux-form';
import styles from '../../styles/forms/add_task_dependency_wizard/AddTaskDependencyForm.scss';
import Button from '../../components/Button';
import { __, mapStateToProps, setTableParams } from '../../core/utils';
import { withRouter } from 'react-router';
import MeetingTasksChooser from '../../components/MeetingTasksChooser';
import { listPossibleTaskDependencies } from '../../redux/actions/table/all_tasks';

@withRouter
@reduxForm({ form: 'add_task_dependency_wizard.add_task_dependency' })
@mapStateToProps((state) => ({
  store: state.table.all_tasks,
}))
class AddTaskDependencyForm extends Component {
  constructor(props) {
    super(props);

    this.state = {
      possible_dependency_tasks: [],
    };
  }

  componentDidMount() {
    const wizard = this.props.store.add_task_dependency_wizard;

    listPossibleTaskDependencies(wizard.task_id, wizard.direction).then(
      ({ response }) => {
        this.setState({ possible_dependency_tasks: response.data || [] });
      }
    );
  }

  render() {
    const { possible_dependency_tasks } = this.state;
    const direction = this.props.store.add_task_dependency_wizard?.direction;

    return (
      <Form onSubmit={this.props.handleSubmit} className={styles.wrapper}>
        <div className={styles.form}>
          <Field
            name='task_ids'
            component={MeetingTasksChooser}
            label={
              direction === 'predecessor'
                ? __('task.dependencies.predecessors')
                : __('task.dependencies.successors')
            }
            tasks={possible_dependency_tasks}
          />
        </div>
        <div className={styles.footer}>
          <Button
            lightGray
            medium
            left
            middleText={__('button.cancel')}
            onClick={() =>
              setTableParams('all_tasks', {
                add_task_dependency_wizard: undefined,
              })
            }
          />
          <Button
            lightBlue
            medium
            right
            submit
            middleText={__('button.add')}
            spinning={this.props.submitting}
          />
        </div>
      </Form>
    );
  }
}

export default AddTaskDependencyForm;
